module.exports = __webpack_public_path__ + "static/media/isolatoir.43f20857.jpg";